    let fallbackData:{[key:string]: string | null} = {};
    const fallbackStorage: Storage = {
        getItem: function (key: string) {
            return fallbackData[key];
        },
        setItem: function (key: string, value: string) {
            return fallbackData[key] = value;
        },
        removeItem: function (key: string) {
            return delete fallbackData[key];
        },
        //Need to implement this stuff to conform to Storage
        key: function (): string {
            return "";
        },
        clear: function (): void {
            fallbackData = {};
        },
        length: Object.keys(fallbackData).length
    };

    const storageEngine = hasLocalStorage() ? (localStorage || sessionStorage || fallbackStorage) : fallbackStorage;

    function _getItem(key:string) {
        return storageEngine.getItem(key);
    }

    function _setItem(key: string, value: string) {
        return storageEngine.setItem(key, value);
    }

    function _removeItem(key:string) {
        return storageEngine.removeItem(key);
    }

    const tokenStorageService = {
        getItem: _getItem,
        setItem: _setItem,
        removeItem: _removeItem
    };

    function hasLocalStorage(): boolean {
        try {
            localStorage.setItem('hasLocalStorageTest', '');
            localStorage.removeItem('hasLocalStorageTest');
            return true;
        } catch(e) {
            return false;
        }
    }

    export default tokenStorageService;

